'use client'

import { Box, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/pro-duotone-svg-icons";

const StyledDivider = (
    {
        icon,
        label
    }: {
        icon: IconDefinition;
        label: string;
    }
) => {
    return <Box
        display={"flex"}
        alignItems={"center"}
        gap={.25}
        mt={1}
        mb={.5}
    >
        <Typography
            component={"i"}
            color={"secondary.main"}
        >
            <FontAwesomeIcon
                icon={icon}
            />
        </Typography>
        <Typography
            component={"span"}
            textTransform={"capitalize"}
            color={"text.primary"}
            whiteSpace="nowrap"
        >
            {
                label
            }
        </Typography>
        <Box
            bgcolor={"custom.brown"}
            borderRadius={1}
            width={"100%"}
            height={0}
            sx={{
                py: '.25rem',
                opacity: .75,
                backgroundImage: (theme) => theme?.palette?.custom?.brownStripGradient,
                backgroundSize: '1rem 1rem'
            }}
        ></Box>
    </Box>
}

export default StyledDivider;